var React = require('react');

function IconReplay (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M772 688l48.8 40.9c-10.3 16.6-21.8 32.5-34.4 47.4C641.2 949.4 383.2 972 210.1 826.8S14.5 423.5 159.7 250.5 562.9 54.8 736 200.1c45.4 38.1 80.4 83.9 104.8 133.9l118.6-47.4L901 520.3 667.2 403.4l115-46c-20.5-40.7-49.5-78-86.6-109.1C549.2 125.4 330.9 144.5 208 291s-103.8 364.7 42.7 487.6 364.7 103.8 487.6-42.7c12.5-15 23.8-31 33.7-47.9zM404 313.1l252.6 198.7c5.3 4.2 5 12.2-.5 16.1L404 702.9V313.1z"}));
}

IconReplay.displayName = "IconReplay";

IconReplay.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconReplay;

IconReplay.default = IconReplay;
